import { type CSSProperties } from 'react';

/**
 * The sizes a shell gives the card inside it. The shell sets them as CSS
 * custom properties, and EmbeddedCardLayout and EmbeddedNeedHelpSection read
 * them in their classes (`var(--embedded-…)`), so both keep one look and never
 * check whether they are in the card or the drawer.
 *
 * The appearance-only variables (`--button-radius`, `--embedded-sheet-radius`)
 * are not shell sizes: their defaults are the CSS
 * fallbacks where they are read, and useEmbeddedAppearance overrides them.
 */
export type ShellSizes = {
  minHeight: number;
  maxHeight: number;
  /** 0 in the drawer, where the sheet is the edge. */
  borderWidth: number;
  radius: number;
  helpRowHeight: number;
  /** Touch height of a help link. */
  linkHeight: number;
  linkPaddingX: number;
};

export function shellSizeStyle(sizes: ShellSizes): CSSProperties {
  return {
    '--embedded-min-h': `${sizes.minHeight}px`,
    '--embedded-max-h': `${sizes.maxHeight}px`,
    '--embedded-border': `${sizes.borderWidth}px`,
    '--embedded-radius': `${sizes.radius}px`,
    '--embedded-help-row-h': `${sizes.helpRowHeight}px`,
    '--embedded-link-h': `${sizes.linkHeight}px`,
    '--embedded-link-px': `${sizes.linkPaddingX}px`,
  } as CSSProperties;
}
